import React, { Component } from "react";
import * as Icon from "react-feather";

class NumberField extends Component {
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      value: defaultValue,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  onIncrement = () => {
    const { value } = this.state;
    const { max } = this.props;
    
    // Check if max is defined and current value is already at max
    if (max !== undefined && parseInt(value) >= max) {
      return;
    }
    
    this.setState(
      (prevState) => ({
        value: parseInt(prevState.value) + 1
      }),
      () => {
        const { value } = this.state;
        const { onChange } = this.props;
        onChange(value);
      }
    );
  };

  onDecrement = () => {
    const { value } = this.state;
    if (value === 0) return;

    this.setState(
      (prevState) => ({
        value: parseInt(prevState.value) - 1
      }),
      () => {
        const { value } = this.state;
        const { onChange } = this.props;
        onChange(value);
      }
    );
  };

  render() {
    const { value } = this.state;
    return (
      <div className="number-input-field">
        <span onClick={this.onDecrement}>
          <Icon.Minus size="16" />
        </span>
        <input type="text" className="w-100" disabled value={value} />
        <span onClick={this.onIncrement}>
          <Icon.Plus size="16" />
        </span>
      </div>
    );
  }
}

export default NumberField;
